var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiteImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7045_182315)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13.75V16M16 16V18.25M16 16H13C12.1716 16 11.5 16.6716 11.5 17.5V18.25M16 16H19C19.8284 16 20.5 16.6716 20.5 17.5V18.25M10.75 18.25H12.25C12.6642 18.25 13 18.5858 13 19V19.75C13 20.1642 12.6642 20.5 12.25 20.5H10.75C10.3358 20.5 10 20.1642 10 19.75V19C10 18.5858 10.3358 18.25 10.75 18.25ZM15.25 18.25H16.75C17.1642 18.25 17.5 18.5858 17.5 19V19.75C17.5 20.1642 17.1642 20.5 16.75 20.5H15.25C14.8358 20.5 14.5 20.1642 14.5 19.75V19C14.5 18.5858 14.8358 18.25 15.25 18.25ZM19.75 18.25H21.25C21.6642 18.25 22 18.5858 22 19V19.75C22 20.1642 21.6642 20.5 21.25 20.5H19.75C19.3358 20.5 19 20.1642 19 19.75V19C19 18.5858 19.3358 18.25 19.75 18.25ZM15.25 11.5H16.75C17.1642 11.5 17.5 11.8358 17.5 12.25V13C17.5 13.4142 17.1642 13.75 16.75 13.75H15.25C14.8358 13.75 14.5 13.4142 14.5 13V12.25C14.5 11.8358 14.8358 11.5 15.25 11.5Z",
    stroke: "#F0F0F0",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7045_182315",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7045_182315"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7045_182315",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteImg);
export default __webpack_public_path__ + "static/media/site-img.c6992040bc2bd2de27bf46006c2eb041.svg";
export { ForwardRef as ReactComponent };